import React from"react";var Anchor=React.memo((function(_ref){var anchorKey=_ref.anchorKey,type=_ref.type;return React.createElement("div",{key:anchorKey,type:type,"data-hook":anchorKey})}));export{Anchor as default};
//# sourceMappingURL=Anchor.js.map
